import { Component } from '@angular/core';

@Component({
  selector: 'app-scorp-cgv-fr',
  templateUrl: './scorp-cgv-fr.component.html',
  styleUrls: ['./scorp-cgv-fr.component.scss'],
  standalone: false,
})
export class ScorpCgvFrComponent {}
